import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormLabelComponent,
} from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FilterData } from '../../admin-strategy';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@Component({
  selector: 'app-additional-predicates',
  standalone: true,
  imports: [
    NzFormItemComponent,
    NzFormControlComponent,
    NzFormLabelComponent,
    NzSelectModule,
    CommonModule,
    ReactiveFormsModule,
    NzCheckboxModule,
    FormsModule,
  ],
  templateUrl: './additional-predicates.component.html',
  styleUrl: './additional-predicates.component.scss',
})
export class AdditionalPredicatesComponent {
  @Input() predicatesForm!: FormGroup;
  @Input() environments: FilterData[] = [];
  @Input() ageLevels: FilterData[] = [];
  @Input() functions: FilterData[] = [];
  @Input() settingEvents: FilterData[] = [];
  @Input() antecedents: FilterData[] = [];
  @Input() languageLevel: FilterData[] = [];
  @Input() behaviourConsequence: FilterData[] = [];

  isInvalid(fieldName: string): boolean {
    const field = this.predicatesForm.get(fieldName);
    return !!field?.invalid && (!!field?.dirty || !!field?.touched);
  }

  getError(fieldName: string): string {
    const control = this.predicatesForm.get(fieldName);
    if (!control?.errors) return '';

    const errors = control.errors;
    const errorMessages = {
      required: `${fieldName} is required`,
      minlength: `Minimum ${errors['minlength']?.requiredLength} characters needed`,
      maxlength: `Maximum ${errors['maxlength']?.requiredLength} characters allowed`,
    };

    return (
      Object.keys(errors).map(
        key => errorMessages[key as keyof typeof errorMessages]
      )[0] || ''
    );
  }

  trackByFn(index: number, item: FilterData): number {
    return item.id;
  }
}
